import { useMemo, useState } from 'react'

import { Constants } from '@adobe/aem-spa-page-model-manager'
import { useFlexOffers } from '@cox/core-ui8/dist/useFlexOffers'

import ReactImageCarouselLargeScreen from './ReactImageCarouselLargeScreen'
import ReactImageCarouselSmallScreen from './ReactImageCarouselSmallScreen'
import { getFlexOffersLength } from '../../../utils/rule-builder-util'
import { ContentType } from '../../../utils/types'
import ReactSectionHeader from '../../ReactSectionHeader'
import { ImageryContentFragment } from '../types'
import './ReactImageCarousel.scss'

const ReactImageCarousel = (props: any): JSX.Element => {
  const {
    ruleExpression = '',
    condition,
    ruleType,
    tokenProperties,
    isInEditor = false,
    contentType,
    cqItemsOrder,
    cqItems,
    eyebrow,
    title,
    activePip,
    inActivePip,
    selectedSlideId,
    resetSlideId
  } = props
  const flexOffers = useFlexOffers(ruleExpression)
  const [activeIndex] = useState()
  // sets Carousel Items array and adds active index
  const carouselItems = useMemo(() => {
    const itemsOrder = cqItemsOrder.length > 0 ? cqItemsOrder : props[Constants.ITEMS_ORDER_PROP]
    const items = Object.keys(cqItems).length > 0 ? cqItems : props[Constants.ITEMS_PROP]
    const flexOffersLength = getFlexOffersLength(flexOffers)
    const contentFragments: ImageryContentFragment[] = itemsOrder.map((i: string) => {
      items[i].isActive = items[i].id === activeIndex
      // setActiveIndex(activeIndex)
      return items[i]
    })
    const carouselItems: ImageryContentFragment[] = []
    contentFragments?.forEach((fragment: ImageryContentFragment, index) => {
      if ((index < flexOffersLength && contentType === ContentType.dynamic) || contentType === ContentType.static) {
        carouselItems.push(fragment)
      }
    })
    return carouselItems.filter((elm) => elm)
  }, [cqItemsOrder, cqItems])

  return (
    <div data-testid={`react-image-carousel`} className={`react-image-carousel`}>
      <div className='carousel-header-text-container' data-testid='carousel-header-text-container'>
        <ReactSectionHeader
          eyebrow={{ value: eyebrow, isRTE: true, placeholderXS: 4 }}
          title={{
            value: title,
            isRTE: true,
            placeholderXS: 7,
            containerClass: 'imagery-custom-title'
          }}
          loading={flexOffers?.loading}
          isInEditor={isInEditor}
        />
      </div>
      <div className='image-carousel-container'>
        {/*  css hide/show depending on breakpoint */}
        <ReactImageCarouselSmallScreen
          carouselItems={carouselItems}
          ruleExpression={ruleExpression}
          condition={condition}
          ruleType={ruleType}
          tokenProperties={tokenProperties}
          activePip={activePip}
          inActivePip={inActivePip}
          selectedSlideId={selectedSlideId}
          resetSlideId={resetSlideId}
          flexOffers={flexOffers}
        />
        <ReactImageCarouselLargeScreen
          carouselItems={carouselItems}
          isInEditor={isInEditor}
          ruleExpression={ruleExpression}
          condition={condition}
          ruleType={ruleType}
          tokenProperties={tokenProperties}
          selectedSlideId={selectedSlideId}
          resetSlideId={resetSlideId}
        />
      </div>
    </div>
  )
}

export default ReactImageCarousel
